export default [
  {
    url: "/admin/dashboard",
    name: "Admin Profile",
    icon: "bxs-user-pin"
  },
  // {
  //   url: "#",
  //   name: "Edit Pages",
  //   icon: "bxs-pencil"
  // },
  {
    url: "/admin/subscribers",
    name: "Subscribers",
    icon: "bxs-user-detail"
  },
  {
    url: "/admin/tickets",
    name: "Tickets",
    icon: "bxs-chat"
  },
  {
    url: "/admin/signals",
    name: "Signals",
    icon: "bx-chart"
  },
  {
    name: "Logout",
    icon: "bx-log-out",
    operation: "logout",
    type: 'admin'
  }
];
